/**********************************************************************
 ** settings Routes                                                   **
 **********************************************************************/

(function () {
  'use strict';

  angular
    .module('home')
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // settings menu
      $stateProvider.state('settings', {
        url: '/settings',
        abstract: true,
        views: {
          'mainmd': {
            template: `
              <div ui-view="settingsmain"></div>
              <div ui-view="sm2"></div>
              <div ui-view="sm3"></div>
              <div ui-view="sm4"></div>
              <div ui-view="sm5"></div>
            `
          },
          'rb1': {
            component: 'todowidget'
          },
          'rb2': {
            component: 'chat'
          }
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('settings state entered, params: ', $state.params);
        }]
      });

      $stateProvider
        .state('settings.services', {
          url: '/services',
          views: {
            settingsmain: {template: `
                <privcatnewentry></privcatnewentry>
                <privcatnewgroup></privcatnewgroup>
                <h3>Bestehende Leistungsgruppen</h3>
                <privcatgrouplist></privcatgrouplist>
                <h3>Bestehende Privatleistungen</h3>
                <privcatentrylist></privcatentrylist>

`}
          }
        });

      $stateProvider
        .state('settings.doctors', {
          url: '/doctors',
          views: {
            settingsmain: {template: `
            <h3>Arztsuche</h3>
            <doctorsearch editinplace="true"></doctorsearch>
            <doctornew></doctornew>
            <h3>Ärtzeverzeichnis</h3>
            <doctorlist editinplace="true"></doctorlist>
            `}
          }
        });


      $stateProvider
        .state('settings.examtemplate', {
          url: '/examtemplate',
          views: {
            settingsmain: {component: 'examtemplatenew'},
            sm2: {component: 'examtemplatelist'}
          },
          onEnter: function () {
            console.log('settings.examtemplate entered');
          }
        });

      $stateProvider
        .state('settings.labvalues', {
          url: '/labvalues',
          views: {
            settingsmain: {component: 'labvalueconfig'}
          },
          onEnter: function () {
            console.log('settings.labavalueconfig entered');
          }
        });

      $stateProvider
        .state('settings.imgvalues', {
          url: '/imgvalues',
          views: {
            settingsmain: {component: 'imagingconfig'}
          },
          onEnter: function () {
            console.log('settings.imgvalues config entered');
          }
        });


      $stateProvider
        .state('settings.aidevalues', {
          url: '/aidevalues',
          views: {
            settingsmain: {component: 'aideconfig'}
          },
          onEnter: function () {
            console.log('settings.aideconfig entered');
          }
        });

      $stateProvider
        .state('settings.dms', {
          url: '/dms',
          views: {
            settingsmain: {component: 'documentconfig'}
          },
          onEnter: function () {
            console.log('settings.dms configentered');
          }
        });

      $stateProvider
        .state('settings.drugconfig', {
          url: '/drugconfig',
          views: {
            settingsmain: {component: 'drugconfig'}
          },
          onEnter: function () {
            console.log('settings.drugconfig entered');
          }
        });

      $stateProvider
        .state('settings.dicom', {
          url: '/dicomconfig',
          views: {
            settingsmain: {component: 'dicomconfig'}
          },
          onEnter: function () {
            console.log('settings.dicomconfig entered');
          }
        });

/*      $stateProvider
        .state('settings.gdtsoftware', {
          url: '/gdtsoftwareconfig',
          views: {
            settingsmain: {component: 'gdtsoftwareconfig'}
          },
          onEnter: function () {
            console.log('settings.gdtsoftwareconfig entered');
          }
        });*/

      $stateProvider
        .state('settings.gdtprofil', {
          url: '/gdtprofilconfig',
          views: {
            settingsmain: {component: 'gdtprofilconfig'}
          },
          onEnter: function () {
            console.log('settings.gdtprofilconfig entered');
          }
        });


      // TODO: not sure how much customizing is still left
      $stateProvider
        .state('settings.config', {
          url: '/config',
          views: {
            settingsmain: {component: 'genconfig'}
          },
          onEnter: function () {
            console.log('settings.genconfig entered');
          }
        });


      $stateProvider
        .state('settings.svs', {
          url: '/svs',
          views: {
            settingsmain: {template: `
            <!--<h3>Arztsuche</h3>-->
            <!--<ssearch editinplace="true"></ssearch>-->
            <svnew></svnew>
            <h3>Sozialversicherungen</h3>
            <svlist editinplace="true"></svlist>
            `}
          }
        });

      // TODO
      $stateProvider
        .state('settings.shares', {
          url: '/shares',
          views: {
            settingsmain: {template: '<h3>Neues Netzlaufwerk anlegen</h3>'},
            sm2: {component: 'sharenew'},
            sm3: {template: '<h3>Netzlaufwerke</h3>'},
            sm4: {component: 'sharelist'}
          }
        });


      $stateProvider
        .state('settings.tracker', {
          url: '/tracker',
          views: {
            settingsmain: {template: `
              <trackernew></trackernew>
              <h3>Bestehende Tacker</h3>
              <trackerlist></trackerlist>
            `}
          }
        });

      $stateProvider
        .state('settings.users', {
          url: '/users',
          views: {
            settingsmain: {template:
              `
                <usernew></usernew>
                <h3>Benutzer</h3>
                <userlist></userlist>
              `
            }
          }
        });

      $stateProvider
        .state('settings.dts', {
          url: '/dts',
          views: {
            settingsmain: {template: '<doctypelist></doctypelist>'}
          }
        });


      $stateProvider
        .state('version', {
          url: '/version',
          views: {
            mainmd: {template: '<version></version>'}
          }
        });


    }
// klammerfriedhof
  }
}());